/// <amd-module name="TFS/Admin/Views/OrganizationOverview/Components/SoftDeletedProjects/RestoreTable" />
import * as React from "react";

import AdminResources = require("TFS/Admin/Views/OrganizationOverview/Resources");
import { TeamProjectReference } from "Tfs/Platform/Contracts/Core";
import { format } from "VSS/Core/Util/String";
import { Card } from "VSSUI/Card";
import { IListSelection, ListSelection } from "VSSUI/List";
import { ITableColumn, SimpleTableCell, Table, TwoLineTableCell } from "VSSUI/Table";
import { ArrayItemProvider } from "VSSUI/Utilities/Provider";
import { VssPersona } from "VSSUI/VssPersona";

export interface IRestoreTableProps {
    softDeletedProjects: TeamProjectReference[];
    OnSelectedProject: (project: TeamProjectReference) => void;
    selectedProject?: TeamProjectReference;
}

interface IRestoreTableState {
    selectedProject: IListSelection;
}

export class RestoreTable extends React.Component<IRestoreTableProps, IRestoreTableState> {
    public locationColumns = [
        { id: "icon", name: AdminResources.Icon, width: 58, renderCell: this.renderIcon },
        { id: "name", name: AdminResources.Name, width: -100, renderCell: this.renderName }
    ];
    constructor(props: IRestoreTableProps) {
        super(props);
        this.state = {
            selectedProject: new ListSelection(false)
        };
    }

    public render(): JSX.Element {
        return (
            <Card className="restore-project-table" contentProps={{ contentPadding: false }}>
                <Table<TeamProjectReference>
                    columns={this.locationColumns}
                    itemProvider={new ArrayItemProvider<TeamProjectReference>(this.props.softDeletedProjects)}
                    singleClickActivation={true}
                    selection={this.state.selectedProject}
                    onSelect={(event, data) => {
                        this.props.OnSelectedProject(this.props.softDeletedProjects[data.index]);
                        this.state.selectedProject.selected(data.index);
                    }}
                    showHeader={false}
                    scrollable={true}
                />
            </Card>
        );
    }

    public componentDidUpdate() {
        if (!this.props.selectedProject && this.state.selectedProject.selectedCount > 0) {
            this.state.selectedProject.clear();
        }
    }

    private renderIcon(rowIndex: number, columnIndex: number, tableColumn: ITableColumn<TeamProjectReference>, tableItem: TeamProjectReference) {
        return (
            <SimpleTableCell key={"row" + rowIndex + "col" + columnIndex} columnIndex={columnIndex} tableColumn={tableColumn}>
                <VssPersona
                    identityDetailsProvider={{
                        getIdentityImageUrl: (size: number): string => {
                            return tableItem.defaultTeamImageUrl;
                        },
                        getDisplayName: (): string => {
                            return tableItem.name;
                        }
                    }}
                    size={"medium"}
                    cssClass="soft-deleted-persona"
                />
            </SimpleTableCell>
        );
    }

    private renderName(rowIndex: number, columnIndex: number, tableColumn: ITableColumn<TeamProjectReference>, tableItem: TeamProjectReference) {
        return (
            <TwoLineTableCell
                key={"row" + rowIndex + "col-" + columnIndex}
                columnIndex={columnIndex}
                tableColumn={tableColumn}
                line1={<span className="fontWeightSemiBold fontSizeMM">{tableItem.name}</span>}
                line2={<span>{_getDeletedDate(tableItem.lastUpdateTime)}</span>}
            />
        );
    }
}

function _getDeletedDate(deletedDate: Date) {
    return format(AdminResources.DeletedText, deletedDate.toLocaleDateString(undefined, { day: "2-digit", month: "2-digit", year: "numeric" }));
}
